/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "common": {
            "nested": {
              "component": {
                "nested": {
                  "RichText": {
                    "fields": {
                      "html": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "markdown": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "segmentedText": {
                        "type": ".squareup.bbfrontend.common.component.SegmentedText",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "SegmentedText": {
                    "fields": {
                      "segments": {
                        "type": ".squareup.bbfrontend.common.component.Segment",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "Segment": {
                    "fields": {
                      "text": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "linkText": {
                        "type": ".squareup.bbfrontend.common.component.Segment.LinkText",
                        "id": 2,
                        "rule": "optional"
                      },
                      "spanStyles": {
                        "type": ".squareup.bbfrontend.common.component.Segment.SpanStyle",
                        "id": 3,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "LinkText": {
                        "fields": {
                          "placeholder": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "clickableText": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "url": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "SpanStyle": {
                        "values": {
                          "SPAN_STYLE_DO_NOT_USE": 0,
                          "BOLD": 1,
                          "ITALIC": 2,
                          "UNDERLINE": 3,
                          "SUPERSCRIPT": 4,
                          "SUBSCRIPT": 5
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.RichText && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.SegmentedText && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.Segment && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.Segment?.nested?.LinkText && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.Segment?.nested?.SpanStyle) {
  $root.addJSON(jsonData);
}

/**
 * Rich text provides different formatted text so the client can pick which one they would like to render.
 * For example, iOS markdown is the only way, and on Android we have a custom [SegmentedText] until
 * we fully support markdown.
 *
 * We no longer support dashboard web for new features on bb-frontend, so html field is deprecated.
 *
 * SOURCE RichText @ squareup/bbfrontend/common/component/rich_text.proto at 18:1
 */
export const RichText = $root.lookupType('squareup.bbfrontend.common.component.RichText');
fixType(RichText, {
  markdown: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(RichText);
/**
 * Idea behind this is that we will pass down an array of [Segment]s that the client can loop
 * through and render.
 *
 * SOURCE SegmentedText @ squareup/bbfrontend/common/component/rich_text.proto at 28:1
 */
export const SegmentedText = $root.lookupType('squareup.bbfrontend.common.component.SegmentedText');
fixType(SegmentedText);
Builder.createAndAttachToType(SegmentedText);
/**
 * Segment will support different span_styles like Bolding, Italic, etc as well as clickable
 * inlined text.
 *
 * Example:
 * Segment {
 *   text = "Some text with clickable {link_placeholder}",
 *   link_text = LinkText(
 *      placeholder = "link_placeholder",
 *      clickable_text = "text",
 *      url = "https://www.squareup.com",
 *   ),
 *   span_styles = listOf(BOLD),
 * }
 *
 * Should render as "Some text with clickable text" - with the "text" being a clickable word that
 * routes you to https://www.squareup.com.
 *
 * SOURCE Segment @ squareup/bbfrontend/common/component/rich_text.proto at 50:1
 */
export const Segment = $root.lookupType('squareup.bbfrontend.common.component.Segment');
fixType(Segment, {
  text: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(Segment);
/**
 * SOURCE LinkText @ squareup/bbfrontend/common/component/rich_text.proto at 65:3
 */
Segment.LinkText = $root.lookupType('squareup.bbfrontend.common.component.Segment.LinkText');
fixType(Segment.LinkText, {
  placeholder: {
    notEmpty: true
  },
  clickableText: {
    notEmpty: true
  },
  url: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(Segment.LinkText);
/**
 * SOURCE SpanStyle @ squareup/bbfrontend/common/component/rich_text.proto at 73:3
 */
Segment.SpanStyle = $root.lookupEnum('squareup.bbfrontend.common.component.Segment.SpanStyle').values;